<template>

    <div class="container">

        <app-head title="Mail Test" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Mail-Test') }}</h1>
            <div class="">
            </div>
        </div>

        <form @submit.prevent="form.post(route('admin.mail-test.submit'))">

            <fieldset>
                <text-input type="email" label="email" v-model="form.email" :error="form.errors.email" />
            </fieldset>

            <div class="d-flex align-items-center w-100">
                <submit-button :label="__('Submit')" :form="form" />
            </div>

        </form>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
        ],
        data() {
            return {
                form: this.$inertia.form({
                    email: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
    }
</script>